module.exports = __webpack_public_path__ + "static/img/solve6.5195b2f9.png";